import { gql } from '@apollo/client';

export const EVM_TOPIC_INSTRUCTION = gql`
  fragment EvmTopicInstruction on EvmTopicInstruction {
    id
    instructionId
    txnTopicFingerprint
    topicInstruction
  }
`;
